import MuiTypography, {
  TypographyProps as Props
} from '@material-ui/core/Typography'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

export type BodyVariants =
  | 'lg'
  | 'lgMedium'
  | 'lgBold'
  | 'mdBold'
  | 'smBold'
  | 'xsMedium'
  | 'xsBold'
  | 'xxsMedium'

export type StyledTypography = {
  bodyVariants?: BodyVariants
  component?: React.ElementType
}
export type TypographyProps = Props & StyledTypography

const bodyLargeStyle = {
  fontSize: 18,
  lineHeight: 1.44,
  fontStyle: 'normal'
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    lg: {
      ...bodyLargeStyle
    },
    lgMedium: {
      ...bodyLargeStyle,
      fontWeight: 500
    },
    lgBold: {
      ...bodyLargeStyle,
      fontWeight: 700
    },
    mdBold: {
      ...theme.typography.body1,
      fontWeight: 700
    },
    smBold: {
      ...theme.typography.body2,
      fontWeight: 700
    },
    xsMedium: {
      ...theme.typography.overline,
      fontWeight: 500
    },
    xsBold: {
      ...theme.typography.overline,
      fontWeight: 700
    },
    xxsMedium: {
      ...theme.typography.caption,
      fontWeight: 500
    }
  })
)

const Typography: React.FC<TypographyProps> = (props) => {
  const classes = useStyles()
  const { bodyVariants, children, ...rest } = props
  const getClasses = (variant: string) => {
    if (bodyVariants === variant) {
      return { root: classes[variant] }
    }
  }
  return (
    <MuiTypography classes={getClasses(bodyVariants as string)} {...rest}>
      {' '}
      {children}{' '}
    </MuiTypography>
  )
}

export default Typography
